import { render } from "./NotificationCenter.vue?vue&type=template&id=60243c7b&scoped=true"
import script from "./NotificationCenter.vue?vue&type=script&lang=js"
export * from "./NotificationCenter.vue?vue&type=script&lang=js"

import "./NotificationCenter.vue?vue&type=style&index=0&id=60243c7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60243c7b"]])

export default __exports__